// extracted by mini-css-extract-plugin
module.exports = {"vColumnGutter":"8px","columns":"columns_columns__Aidki","column":"columns_column__2Yz_s","column_1_2":"columns_column_1_2__1jfoB","column_1_3":"columns_column_1_3__24sEb"};